var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessageReceived = function SvgMessageReceived(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#909A9F",
    d: "m4.788 27.484 9.486 7.24 15.232-17.408-3.012-2.632-12.768 14.592-6.514-4.972zm38.718-10.168-3.012-2.632-12.738 14.558-1.506-1.204-2.5 3.124 4.494 3.596z"
  })));
};
export { SvgMessageReceived as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQuNzg4MDkgMjcuNDg0MUwxNC4yNzQxIDM0LjcyNDFMMjkuNTA2MSAxNy4zMTYxTDI2LjQ5NDEgMTQuNjg0MUwxMy43MjYxIDI5LjI3NjFMNy4yMTIwOSAyNC4zMDQxTDQuNzg4MDkgMjcuNDg0MVpNNDMuNTA2MSAxNy4zMTYxTDQwLjQ5NDEgMTQuNjg0MUwyNy43NTYxIDI5LjI0MjFMMjYuMjUwMSAyOC4wMzgxTDIzLjc1MDEgMzEuMTYyMUwyOC4yNDQxIDM0Ljc1ODFMNDMuNTA2MSAxNy4zMTYxWiIgZmlsbD0iIzkwOUE5RiIvPgo8L3N2Zz4K";